import { styled } from "styled-components"
import { CheckIcon } from "@heroicons/react/24/outline"
import { black, white, yellow } from "./colors"

const Label = styled.span``
const CheckboxGraphics = styled.span<{ $checked?: boolean }>`
  width: 1.7rem;
  height: 1.7rem;
  border-radius: 100%;
  flex-shrink: 0;
  border-color: ${white};
  border-style: solid;
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 0.2rem;
  cursor: pointer;
  color: ${white};

  & > svg {
    stroke-width: 3;
  }
`

const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  font-weight: bold;
  color: ${white};
  text-transform: uppercase;
  font-weight: bold;
  height: 56px;

  & > label {
    color: ${black};
    font-size: 0.8rem;
    font-weight: bold;
    text-transform: uppercase;
    background-color: ${white};
    width: fit-content;
    border-radius: 0.2rem;
    padding: 0.1rem 0.5rem;
    position: relative;
    left: 1rem;
    top: 0.7rem;
  }
`

export const Checkbox: React.FC<{
  label?: string
  disabled?: boolean
  onChange: (boolean) => void
  checked?: boolean
  className?: string
}> = ({ label, className = "", checked = false, onChange }) => {
  return (
    <InputContainer className={className}>
      <Label>{label}</Label>
      <CheckboxGraphics onClick={() => onChange(!checked)}>
        {checked && <CheckIcon style={{ width: '20px', height: '20px'}} />}
      </CheckboxGraphics>
    </InputContainer>
  )
}
